module.exports = __webpack_public_path__ + "img/Coban.2d9badb1.svg";